import { z } from "zod";

import {
	PriceRankDailyStatusItemInputSchema,
	RoomPriceRankDailyStatusInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

export const roomPriceRankDailyStatusZodSchema = RoomPriceRankDailyStatusInputSchema.extend({
	statuses: z.array(
		z.lazy(() =>
			PriceRankDailyStatusItemInputSchema.extend({
				color: z.string(),
			}),
		),
	),
});

export type RoomPriceRankDailyStatusInputZodSchemaType = z.infer<typeof roomPriceRankDailyStatusZodSchema>;
